import styled from "styled-components";

export const Main = styled.div`
  width: 100%;
  max-width: 1366px;
  /* background-color: white; */
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: space-between;
  gap: 24px;
  padding: 24px;
  margin-top: 24px;
  /* border-radius: 8px; */
  /* box-shadow: 0px 1px 4px rgba(0, 0, 0, 0.1); */
`;

export const Card = styled.div`
  position: relative;
  min-width: 49%;
  min-height: 200px;
  background-color: white;
  padding: 25px;
  border-radius: 8px;
  box-shadow: 0px 1px 4px rgba(0, 0, 0, 0.1);
  display: flex;
  flex-direction: column;
`;

export const Header = styled.h1`
  font-weight: 500;
  font-size: 18px;
  line-height: 160%;
  letter-spacing: 0.15px;
  width: 100%;
  /* color: #0f0f1e99; */
`;

export const Wrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
`;

export const Box = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
  width: 50%;
`;
